package one.healthium.settings.ui.settings

import co.touchlab.kermit.Logger
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.remoteconfig.get
import dev.gitlive.firebase.remoteconfig.remoteConfig
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.LogoutInteractor
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.vm.BaseViewModel
import one.primehealth.app.AppRestartController
import one.primehealth.app.BaseAppConfig

class SettingsViewModel(
    private val logoutInteractor: LogoutInteractor,
    private val appRestartController: AppRestartController,
    private val userInteractor: UserInteractor,
    private val baseAppConfig: BaseAppConfig,
) : BaseViewModel() {

    private val _state = MutableStateFlow(SettingsUiState(baseAppConfig = baseAppConfig))
    val state = _state.asStateFlow()

    init {
        launch {
            userInteractor.observeUser()
                .collect { user ->
                    _state.update { state -> state.copy(userModel = user) }
                }
        }
        launch {
            try {
                Firebase.remoteConfig.apply {
                    val activated = fetchAndActivate()
                    Logger.d("Remote config activated: $activated")
                    val manageSubscriptionEnabled = get<Boolean?>("feature_manage_subscription") ?: false
                    _state.update { state -> state.copy(manageSubscriptionEnabled = manageSubscriptionEnabled) }
                }
            } catch (e: Exception) {
                Logger.e("Error fetching settings remote config", e)
            }
        }
    }

    fun onDeleteAccountClicked() {
        launch {
            try {
                _state.update { state -> state.copy(logoutInProgress = true) }
                logoutInteractor.deleteAccount()
                restartApp()
            } catch (e: Exception) {
                Logger.e("Logout error", e)
            } finally {
                _state.update { state -> state.copy(logoutInProgress = false) }
            }
            _state.update { state ->
                state.copy(
                    logoutInProgress = false,
                    accountDeleted = true,
                )
            }
        }
    }

    fun onLogoutClicked() {
        launch {
            try {
                _state.update { state -> state.copy(logoutInProgress = true) }
                logoutInteractor.logout()
                restartApp()
            } catch (e: Exception) {
                Logger.e("Logout error", e)
            } finally {
                _state.update { state -> state.copy(logoutInProgress = false) }
            }
        }
    }


    private suspend fun restartApp() {
        appRestartController.restart()
    }
}